import React, { useState, useEffect } from "react";
import InquiryModal from "../components/InquiryModal";
import "./Booking.css";
import { getFlights, Flight } from "../components/api/flight";
import airports from "./airports.json"; // ✅ import airports.json

interface FlightForm {
  type: "Flight" | "Hotel" | "Package" | "Insurance";
  tripType: "OneWay" | "Return";  // ✅ new
  from: string;
  to: string;
  date: string;
  returnDate?: string;            // ✅ new
  name: string;
  email: string;
  phone: string;
  nameOfItem: string;
}

const Booking: React.FC = () => {
  const [form, setForm] = useState<FlightForm>({
    type: "Flight",
    tripType: "OneWay",  // default
    from: "",
    to: "",
    date: "",
    returnDate: "",
    name: "",
    email: "",
    phone: "",
    nameOfItem: "",
  });

  const [showInquiry, setShowInquiry] = useState(false);

  const [flights, setFlights] = useState<Flight[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFlights = async () => {
      setLoading(true);
      const data = await getFlights();
      setFlights(data.filter((f) => f.isActive));
      setLoading(false);
    };
    fetchFlights();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowInquiry(true);
  };

  return (
    <div className="booking-container">
      <div className="Selectflightsection">
        <h2>Book Your Flight</h2>

        <form className="booking-form" onSubmit={handleSubmit}>
          {/* ✅ Trip type */}
          <div className="trip-type">
            <label>
              <input
                type="radio"
                name="tripType"
                value="OneWay"
                checked={form.tripType === "OneWay"}
                onChange={handleChange}
              />
              One Way
            </label>
            <label>
              <input
                type="radio"
                name="tripType"
                value="Return"
                checked={form.tripType === "Return"}
                onChange={handleChange}
              />
              Return
            </label>
          </div>

          {/* From & To */}
          <select name="from" value={form.from} onChange={handleChange} required>
            <option value="" disabled>
              From
            </option>
            {airports.map((a) => (
              <option key={a.code} value={`${a.city} (${a.code})`}>
                {a.city}, {a.country} ({a.code})
              </option>
            ))}
          </select>

          <select name="to" value={form.to} onChange={handleChange} required>
            <option value="" disabled>
              To
            </option>
            {airports.map((a) => (
              <option key={a.code} value={`${a.city} (${a.code})`}>
                {a.city}, {a.country} ({a.code})
              </option>
            ))}
          </select>

          {/* Dates */}
          <label>
        Departure Date:

          <input
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
            required
          />
          </label>
          {form.tripType === "Return" && (
            <label>
            Return Date:
           <input
              type="date"
              name="returnDate"
              value={form.returnDate}
              onChange={handleChange}
              required
            />
            </label>
          )}

          <button type="submit">Send Inquiry</button>
        </form>

        <InquiryModal
          show={showInquiry}
          onClose={() => setShowInquiry(false)}
          inquiryData={form}
        />
      </div>

      {/* ✅ Dynamic Flight Offers */}
      <div className="flightOffers">
        <h3>✈ Flight Offers</h3>
        {loading ? (
          <p>Loading flights...</p>
        ) : flights.length > 0 ? (
          <table
            className="offers-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "1rem",
              textAlign: "left",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <thead style={{ backgroundColor: "#285AEB", color: "#fff" }}>
              <tr>
                <th style={{ padding: "0.8rem" }}>Route</th>
                <th style={{ padding: "0.8rem" }}>Airline</th>
                <th style={{ padding: "0.8rem" }}>Type</th>
                <th style={{ padding: "0.8rem" }}>Departure</th>
                <th style={{ padding: "0.8rem" }}>Price (OMR)</th>
              </tr>
            </thead>
            <tbody>
              {flights.map((f) => (
                <tr key={f.id} style={{ borderBottom: "1px solid #ccc" }}>
                  <td style={{ padding: "0.8rem" }}>
                    {f.origin} → {f.destination}
                  </td>
                  <td style={{ padding: "0.8rem" }}>{f.airline}</td>
                  <td style={{ padding: "0.8rem" }}>{f.flightType}</td>
                  <td style={{ padding: "0.8rem" }}>
                    {new Date(f.departure).toLocaleString()}
                  </td>
                  <td style={{ padding: "0.8rem", fontWeight: "bold" }}>
                    {f.price} OMR
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No active flights available.</p>
        )}
      </div>
    </div>
  );
};

export default Booking;
